import React, { useState } from 'react';
import './qualification.css';
import { GiGraduateCap, GiBriefcase } from 'react-icons/gi';
import { VscCalendar } from 'react-icons/vsc';

const Qualification = () => {
    // Toggle between Qualification and Experiance
    const [toggleState, setToggleState] = useState(1);
    
    const toggleTab = (index) => {
        setToggleState(index);
    };

  return (
    <section className='about section' id='about'>
        <h2 className='section__title'>Qualification & Education</h2>
        <h3 className='section__subtitle'>My education and experiences</h3>
        <div className='qualification__container container'>
            <div className='qualification__tabs'>
                <div className={
                    toggleState === 1 ? 'qualification__button button--flex qualification__active'
                    : 'qualification__button button--flex' } onClick = {() => toggleTab(1)}
                >
                     <GiBriefcase className='qualification__icon'/>
                    {""} Experience
                </div>
                <div className={
                    toggleState === 2 ? 'qualification__button button--flex qualification__active'
                    : 'qualification__button button--flex' } onClick = {() => toggleTab(2)}
                >
                    <GiGraduateCap className='qualification__icon'/>
                    {""} Education
                </div>
            </div>
            <div className='qualification__sections'>

                {/* Qualification/ Education */}
                <div className={
                    toggleState === 1 ? 'qualification__content qualification__content-active'
                    : 'qualification__content'} >
                    <div className='qualification__data'>
                        <div>
                            <h3 className='qualification__title'>Frontend Developer</h3>
                            <span className='qualification__subtitle'>Apostrophe Solutions onc</span>
                            <div className='qualification__calendar'>
                                <VscCalendar />
                                Jan 2021 — Present
                            </div>
                        </div>
                        <div>
                            <span className='qualification__rounder'></span>
                            <span className='qualification__line'></span>
                        </div>
                    </div>
                
                    <div className='qualification__data'>
                        <div></div>
                        <div>
                            <span className='qualification__rounder'></span>
                            <span className='qualification__line'></span>
                        </div>
                        <div>
                            <h3 className='qualification__title'>Frontend Developer</h3>
                            <span className='qualification__subtitle'>GRFE</span>
                            <div className='qualification__calendar'>
                            <VscCalendar />
                                May 2018 — Jan 2021
                            </div>
                        </div>
                    </div>

                    <div className='qualification__data'>
                        <div>
                            <h3 className='qualification__title'>Web Develope/ Frontend Developer</h3>
                            <span className='qualification__subtitle'>Stepchange Design</span>
                            <div className='qualification__calendar'>
                                <VscCalendar />
                                June 2017 — May 2018
                            </div>
                        </div>
                        <div>
                            <span className='qualification__rounder'></span>
                            <span className='qualification__line'></span>
                        </div>
                    </div>

                    <div className='qualification__data'>
                        <div></div>
                        <div>
                            <span className='qualification__rounder'></span>
                            <span className='qualification__line'></span>
                        </div>
                        <div>
                            <h3 className='qualification__title'>Web Developer</h3>
                            <span className='qualification__subtitle'>Armico</span>
                            <div className='qualification__calendar'>
                                <VscCalendar />
                                April 2014 — May 2017
                            </div>
                        </div>
                    </div>

                </div>

                {/* Experiences */}
                <div className={
                    toggleState === 2 ? 'qualification__content qualification__content-active'
                    : 'qualification__content'} >
                                        <div className='qualification__data'>
                        <div>
                            <h3 className='qualification__title'>Master of Software Engineering </h3>
                            <span className='qualification__subtitle'>University of Technology</span>
                            <div className='qualification__calendar'>
                                <VscCalendar />
                                Sept 2012 — Sep 2014
                            </div>
                        </div>
                        <div>
                            <span className='qualification__rounder'></span>
                            <span className='qualification__line'></span>
                        </div>
                    </div>
                    <div className='qualification__data'>
                        <div></div>
                        <div>
                            <span className='qualification__rounder'></span>
                            <span className='qualification__line'></span>
                        </div>
                        <div>
                            <h3 className='qualification__title'>Certificate, React & Node.js  </h3>
                            <span className='qualification__subtitle'>Washington University</span>
                            <div className='qualification__calendar'>
                                <VscCalendar />
                                Sep 2018 — Jan 2020
                            </div>
                        </div>
                    </div>
                    <div className='qualification__data'>
                        <div></div>
                        <div>
                            <span className='qualification__rounder'></span>
                            <span className='qualification__line'></span>
                        </div>
                        <div>
                            <h3 className='qualification__title'>Certificate, Media Design & Programming </h3>
                            <span className='qualification__subtitle'>OCAD University</span>
                            <div className='qualification__calendar'>
                                <VscCalendar />
                                Jan 2014 — Jan 2015
                            </div>
                        </div>
                    </div>
                
                </div>
            </div>
        </div>
    </section>
  )
}

export default Qualification